<template>
	<section>
   	<el-col :span="24" style="margin-top:20px;padding-bottom: 0px;">
			<el-form :model="mainForm" label-width="120px" :rules="mainFormRules" ref="mainForm">
			
          <el-col style='background-color:#ff9900;color:white;padding:15px;margin-bottom:10px' v-if="mainForm.pwdreset==true">
          Your password has expired and needs to be reset. Please enter a new value in the password field below.'.
          </el-col>
   
    			<el-form-item label="Login : " prop="Usercode">
	  			  <el-input disabled='disabled' v-model="mainForm.usercode" auto-complete="off"></el-input>
		  		</el-form-item>
				
	  		<el-col :span="24">
		  		<el-form-item label="Name :" prop="username">
			  		<el-input :disabled="mainForm.Usercode=='master'" v-model="mainForm.username" auto-complete="off"></el-input>
				  </el-form-item>
				</el-col>

				<el-col :span="24">
          <el-form-item label="Your Avatar:" prop="useravatar">
            <img :src='curIcon' class='icoon' />
		  			<el-select clearable autocomplete filterable v-if="mainForm.usercode!='master'"  v-model="mainForm.useravatar" value-key='mainForm.useravatar' placeholder='Select Icon' 
												@change='showChanged'>
			  			<el-option style='height:45px' v-for="item in codes.Img" :key="item.Code" :label="item.Desc"   :value="item.Url">
                <img class='icoon' :src="item.IconUrl"><span style='margin:5px 10px;float:left'>{{item.Desc}}</span>
              </el-option>
  		  		</el-select>
				  </el-form-item>
        </el-col>
        
        <el-col style='background-color:#ddd;padding-top:10px;xmargin-top:10px' v-if="mainForm.usercode!='master'">
          <div v-if="mainForm.pwdreset==false" style='font-family:verdana;font-size:12px;color:blue;font-weight:bold;margin: 0 0 10px 20px'>
          Only use these fields if you want to change your password ! </div>
		  		<el-form-item style='margin-top:15px;' label="Password :" prop="password">
			  		<el-input type='password' style='width:300px' v-model="mainForm.password" auto-complete="off"></el-input>
				  </el-form-item>
				</el-col>
	  		<el-col style='background-color:#ddd;padding-bottom:20px;margin-bottom:10px' v-if="mainForm.usercode!='master'">
		  		<el-form-item label="Re-Type PWD :" prop="password2">
			  		<el-input type='password' style='width:300px' v-model="mainForm.password2" auto-complete="off"></el-input>
				  </el-form-item>
				</el-col>
        </div>



				<el-col :span="24" class="toolbar">	  		 
         <el-button v-if="mainForm.usercode!='master'" style='float:Right' type="success" size='small' @click.native="mainSubmit" :loading="mainLoading" icon="el-icon-edit" >Store</el-button>		      					
          <div v-if="mainForm.usercode=='master'" style='font-family:verdana;margin-left:px'> User 'master' cannot be modified. Please contact admin!</div>
		    </el-col>
		  </el-form>    
		</el-col>

	</section>
</template>

<script>
	import util     from '../../common/AppUtil';
  import settings from '../../common/AppSettings';
  import text     from '../../common/AppText';
  import api      from '../../api/system/xprofile';

	export default {
		data() {
			return {
        QID         : util.Initialize(this.$router,"XP"),
        util        : util,
			  stack       : {},
        lang        : text.data,
        codes       : util.codes,
        //pwdexpired  : util.getAuthMode(sessionStorage.getItem('userLevel'),"xprofile"),

        APICode     : "XUser",
        payload: [],
        codes: [],
        header: [],

				mainForm: { },
				mainLoading: false,
				curIcon : "",
				mainFormRules: { 
				},
			}
		},
		methods: {
			
			// Krijg gebruikerslijst
			getRecords() {
				let parg = {};
				this.mainLoading = true;
			
        api.getProfile(parg).then((res) => {					
          util.processMainResults(res);
          this.codes = util.codes;
          this.mainTotal = util.getMainHeader("total_" + this.APICode);
          this.mainForm = util.getMainPayload(this.APICode);
  		    this.MainFormVisible = true;

          if (this.codes.Img) {						
  				  this.codes.Img.forEach(function(item) {
						  item.IconUrl = "./static/" + item.Url;
						});
          };
          
 			    this.curIcon = "./static/" + this.mainForm.useravatar;
          this.mainLoading = false;
				})
        .catch((error) => {
          util.serverError(this);
        });

			},
			
			showChanged: function () {
				this.curIcon = "./static/" + this.mainForm.useravatar;
			},
			
			// uitgeven
			mainSubmit: function () {
			  if (this.mainForm['password']) {
				  var isSame =  this.mainForm.password == this.mainForm.password2;
          if (isSame == false) {
						this.$message({
							message: 'Passwords are not the same!!',
							type: 'error'
						});
						return;
          }
				}
        //sessionStorage.setItem('avatar',this.mainForm.userImg);
				//app.avatar = this.mainForm.userImg;

  			this.mainLoading = true;
				
        let parg = {};
        parg.Params = {};
        parg.Record = Object.assign({}, this.mainForm);
				this.curIcon = "./static/" + this.mainForm.useravatar;
				
				api.saveProfile(parg).then((res) => {
					this.mainLoading = false;
					this.$notify({
					  title: "Profile saved",
						message: "Your profile has been updated, any changes will be visible on next login.",
						 type: 'success'
					});
					this.$router.push({ path: '/' });


					//this.$refs['mainForm'].resetFields();
					//this.getRecords();
				});
			},			
		},

		mounted() {
			this.getRecords();
		}
	}

</script>

<style scoped>
 .icoon {height:30px;width:30px; float:left;margin-right:5px;margin-top:5px}
</style>


// WEBPACK FOOTER //
// xprofile.vue?7aa35c5e